import { Query } from 'react-apollo'
import users, { Users, UsersInput } from '../../graphql/queries/users'
import withQuery from './withQuery'
import { GetProps } from '../../types'

class UsersQuery extends Query<Users, UsersInput> {}

const UsersQueryCompleted = withQuery(users)(UsersQuery)

export type UsersQueryProps = GetProps<typeof UsersQueryCompleted>
export type UsersQueryResult = Users

export default UsersQueryCompleted



// WEBPACK FOOTER //
// ./src/components/queries/UsersQuery.tsx